<template>
    <div
        v-if="license.id"
        class="license-key-container flex"
    >
        <div class="license-key">
            <div class="license-key-scroll-wrapper">
                {{ license.key }}
            </div>
        </div>
        <div
            class="copy-btn"
        >
            <i class="fal fa-copy" />
            Copy
            <base-tooltip>
                Copied!
            </base-tooltip>
        </div>
    </div>
</template>

<script>
import ClipboardJS from 'clipboard';

export default {
    props: {
        license: {
            type: Object,
            default: () => {},
        },
    },

    /**
     * Created hook
     */
    created() {
        this.handleClipboard();
    },

    methods: {
        /**
         * Handles copy to clipboard
         */
        handleClipboard() {
            new ClipboardJS('.copy-btn', {
                target: (trigger) => {
                    trigger.lastChild.classList.add('active');
                    setTimeout(() => trigger.lastChild.classList.remove('active'), 1500);
                },
                text: (trigger) => trigger.previousSibling.previousElementSibling.innerText,
            });
        },
    },
};
</script>
